import React from 'react';

import { ILine } from './_types';
import { Divider } from '@mui/material';

export const Line: React.FC<ILine> = ({ topMargin = 2, bottomMargin = 2 }) => {
  return <Divider sx={{ mt: topMargin, mb: bottomMargin }} />;
};
